import React, { useEffect, useState, useRef } from 'react';
import { setToastHandler } from '../services/api';

// Global transient toast. Registers itself as the app's toast handler so any
// API error (e.g. a 403 "no access") shows a clear message instead of a no-op.
const Toast: React.FC = () => {
  const [toast, setToast] = useState<{ message: string; kind: 'error' | 'info' } | null>(null);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    setToastHandler((message, kind = 'error') => {
      setToast({ message, kind });
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setToast(null), 6000);
    });
    return () => { setToastHandler(null); window.clearTimeout(timer.current); };
  }, []);

  if (!toast) return null;
  const color = toast.kind === 'error' ? 'bg-red-600' : 'bg-brand-700';
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] w-[92%] max-w-md px-2">
      <div className={`${color} text-white text-sm px-4 py-3 rounded-lg shadow-lg flex items-start gap-3`}>
        <span className="flex-1">{toast.message}</span>
        <button onClick={() => setToast(null)} className="opacity-80 hover:opacity-100 flex-shrink-0" aria-label="Dismiss">✕</button>
      </div>
    </div>
  );
};

export default Toast;
